import React from 'react'
import { Checkbox, Divider, Input, Row, Typography } from 'antd'

import { GridFormItem, LinkButton } from '../../../core/components/sections'

import { TypographyLinkWrapper } from '../../../common/components/sections'
import { StyledFlexInputGroup } from '../../../common/components/styled'
import { APP_ROUTES } from '../../../common/constants'

import { brandCurationTaskPropType } from '../../prop-types'

import BrandCurationTaskDuplicateButton from './brand-curation-task-duplicate-button'

const BrandCurationTaskHeader = ({ brandCurationTask }) => (
  <>
    <Row gutter={16}>
      <GridFormItem span={2} label="Menu Curation Task Id">
        <TypographyLinkWrapper
          to={`${APP_ROUTES.MENUS.children.MENU_DETAILS.fullPath}/${brandCurationTask.menuCurationTaskId}`}
          target="_blank"
        >
          {brandCurationTask.menuCurationTaskId}
        </TypographyLinkWrapper>
      </GridFormItem>
      <GridFormItem span={2} label="Brand Id">
        <Typography.Text strong>{brandCurationTask?.brand?.id}</Typography.Text>
      </GridFormItem>
      <GridFormItem span={2} label="Autoeat Id">
        <Typography.Text strong>
          {brandCurationTask?.brand?.autoeatId}
        </Typography.Text>
      </GridFormItem>
      <GridFormItem span={4} label="Name">
        <Typography.Text strong>
          {brandCurationTask?.brand?.name}
        </Typography.Text>
      </GridFormItem>
      <GridFormItem span={4} label="Duplicate">
        <BrandCurationTaskDuplicateButton
          originalBrandId={brandCurationTask.brand?.originalBrandId}
        />
      </GridFormItem>
      <GridFormItem span={2} label="Published">
        <Typography.Text strong>
          <Checkbox checked={brandCurationTask?.brand?.isPublished} disabled />
        </Typography.Text>
      </GridFormItem>
      <GridFormItem span={6} label="Website">
        <StyledFlexInputGroup compact>
          <Input readOnly disabled value={brandCurationTask?.brand?.website} />
          <LinkButton link={brandCurationTask?.brand?.website} shape="square" />
        </StyledFlexInputGroup>
      </GridFormItem>
    </Row>
    <Divider />
  </>
)

BrandCurationTaskHeader.propTypes = {
  brandCurationTask: brandCurationTaskPropType.isRequired,
}

export default BrandCurationTaskHeader
